var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.889 0.541748C10.0106 0.541748 11.0863 0.98732 11.8795 1.78044C12.6726 2.57356 13.1182 3.64927 13.1182 4.77092C13.1182 5.89256 12.6726 6.96827 11.8795 7.76139C11.0863 8.55451 10.0106 9.00008 8.889 9.00008C7.76735 9.00008 6.69165 8.55451 5.89853 7.76139C5.1054 6.96827 4.65983 5.89256 4.65983 4.77092C4.65983 3.64927 5.1054 2.57356 5.89853 1.78044C6.69165 0.98732 7.76735 0.541748 8.889 0.541748ZM8.889 11.1147C13.5622 11.1147 17.3473 13.0072 17.3473 15.3438V17.4584H0.430664V15.3438C0.430664 13.0072 4.21577 11.1147 8.889 11.1147Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e9f759112d0daa49edf6e37719492c2b.svg";
export { ForwardRef as ReactComponent };